import { createAction } from "@reduxjs/toolkit";
import { PartnerHashList } from "types/general";

export const getOffersList = createAction<Partial<PartnerHashList>>(
    'offer/getOffersList',
  );